import { Form } from "@circle-react-uikit/Form";
import type { PostFormValues } from "@circle-react/components/QuickPostV3/data/types";
import { OpenGraphImageDropzone } from "@circle-react/components/QuickPostV3/Settings/OpenGraphImageDropzone";
import { FormField } from "@circleco/compass/components/FormField";
import { useIsMobile } from "@circleco/compass/hooks/useIsMobile";
import { useFormContext } from "react-hook-form";

import { t } from "@/i18n-js/instance";
import { PostCanonicalUrlField } from "@/react/components/PostsV3/PostCanonicalUrlField";

import { SettingsSection } from "./SettingsSection";
import { SettingsSubsection } from "./SettingsSubsection";

export const SharingSection = () => {
  const isMobile = useIsMobile();
  const { watch } = useFormContext<PostFormValues>();
  const createdAt = watch("created_at");

  if (!createdAt) {
    return null;
  }

  return (
    <SettingsSection title={t("quick_post_v3.settings.sections.sharing")}>
      <SettingsSubsection title={t("quick_post_v3.settings.subsections.seo")}>
        <PostCanonicalUrlField
          layout={isMobile ? "vertical" : "horizontal"}
          horizontalLayoutRatio="40/60"
        />
        <FormField
          layout={isMobile ? "vertical" : "horizontal"}
          horizontalLayoutRatio="40/60"
          label={t("meta_tag_attributes.meta_title")}
          labelTooltip={t("meta_tag_attributes.meta_title_description", {
            obj: "post",
          })}
        >
          <Form.Input
            name="meta_tag_attributes.meta_title"
            placeholder={t("quick_post_v3.settings.meta_title_placeholder")}
          />
        </FormField>
        <FormField
          layout={isMobile ? "vertical" : "horizontal"}
          horizontalLayoutRatio="40/60"
          label={t("meta_tag_attributes.meta_description")}
          labelTooltip={t("meta_tag_attributes.meta_description_description")}
        >
          <Form.TextArea
            name="meta_tag_attributes.meta_description"
            rows={4}
            placeholder={t(
              "quick_post_v3.settings.meta_description_placeholder",
            )}
          />
        </FormField>
      </SettingsSubsection>

      <SettingsSubsection
        title={t("quick_post_v3.settings.subsections.social")}
      >
        <FormField
          layout={isMobile ? "vertical" : "horizontal"}
          horizontalLayoutRatio="40/60"
          label={t("spaces.form.edit.options.seo.opengraph_image.label")}
        >
          <OpenGraphImageDropzone />
        </FormField>
        <FormField
          layout={isMobile ? "vertical" : "horizontal"}
          horizontalLayoutRatio="40/60"
          label={t("meta_tag_attributes.opengraph_title")}
          labelTooltip={t("meta_tag_attributes.opengraph_title_description", {
            obj: "post",
          })}
        >
          <Form.Input
            name="meta_tag_attributes.opengraph_title"
            placeholder={t(
              "quick_post_v3.settings.opengraph_title_placeholder",
            )}
          />
        </FormField>
        <FormField
          layout={isMobile ? "vertical" : "horizontal"}
          horizontalLayoutRatio="40/60"
          label={t("meta_tag_attributes.opengraph_description")}
          labelTooltip={t(
            "meta_tag_attributes.opengraph_description_description",
          )}
        >
          <Form.TextArea
            name="meta_tag_attributes.opengraph_description"
            rows={4}
            placeholder={t(
              "quick_post_v3.settings.opengraph_description_placeholder",
            )}
          />
        </FormField>
      </SettingsSubsection>
    </SettingsSection>
  );
};
